/* WattWheelz V60.6 — canonical customer-facing contact number safety net. */
(function(){
  const canonicalDisplay='1-888-598-7034';
  const canonicalDial='+18885987034';
  const legacyText=[
    /(?:\+?1[\s.\-]?)?\(?302\)?[\s.\-]*414[\s.\-]*9758/g,
    /(?:\+?1[\s.\-]?)?\(?623\)?[\s.\-]*934[\s.\-]*2400/g
  ];
  const legacyDigits=new Set(['3024149758','13024149758','6239342400','16239342400']);
  const skip=new Set(['SCRIPT','STYLE','TEXTAREA','INPUT','NOSCRIPT','TEMPLATE','CODE','PRE']);
  function replaceText(value){let out=String(value||'');legacyText.forEach(rx=>{out=out.replace(rx,canonicalDisplay)});return out}
  function normalizePhoneHref(a){
    const href=a.getAttribute('href')||'';
    if(/^(tel|sms):/i.test(href)){
      const scheme=href.split(':')[0].toLowerCase();
      const digits=href.replace(/\D/g,'');
      if(legacyDigits.has(digits))a.setAttribute('href',scheme+':'+canonicalDial);
    }
    if(a.matches('[data-quiz-email-results]')&&href){
      try{const u=new URL(href,location.origin),body=u.searchParams.get('body');if(body){const next=replaceText(body);if(next!==body){u.searchParams.set('body',next);a.href=u.toString()}}}catch(_){}
    }
    if(a.matches('[data-quiz-text-results]')&&href.includes('body=')){
      try{const parts=href.split('body='),body=decodeURIComponent(parts.slice(1).join('body=')),next=replaceText(body);if(next!==body)a.setAttribute('href',parts[0]+'body='+encodeURIComponent(next))}catch(_){}
    }
  }
  function scan(root){
    if(!root)return;
    if(root.nodeType===3){if(!skip.has(root.parentElement?.tagName)){const next=replaceText(root.nodeValue);if(next!==root.nodeValue)root.nodeValue=next}return;}
    if(root.nodeType!==1&&root.nodeType!==9&&root.nodeType!==11)return;
    const el=root.nodeType===1?root:null;
    if(el&&!skip.has(el.tagName)){
      ['aria-label','title'].forEach(attr=>{if(el.hasAttribute?.(attr)){const v=el.getAttribute(attr),n=replaceText(v);if(n!==v)el.setAttribute(attr,n)}});
      if(el.tagName==='A')normalizePhoneHref(el);
    }
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT|NodeFilter.SHOW_ELEMENT);
    let node;while((node=walker.nextNode())){
      if(node.nodeType===3){if(skip.has(node.parentElement?.tagName))continue;const n=replaceText(node.nodeValue);if(n!==node.nodeValue)node.nodeValue=n;}
      else if(!skip.has(node.tagName)){
        ['aria-label','title'].forEach(attr=>{if(node.hasAttribute?.(attr)){const v=node.getAttribute(attr),n=replaceText(v);if(n!==v)node.setAttribute(attr,n)}});
        if(node.tagName==='A')normalizePhoneHref(node);
      }
    }
  }
  function ready(){scan(document.body);new MutationObserver(records=>records.forEach(r=>{if(r.type==='characterData')scan(r.target);r.addedNodes.forEach(scan)})).observe(document.body,{childList:true,subtree:true,characterData:true});}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',ready):ready();
})();